// extracted by mini-css-extract-plugin
export var col_5 = "webinarSolution-module--col_5--57f3c";
export var image_wrapper = "webinarSolution-module--image_wrapper--e7350";
export var img_title = "webinarSolution-module--img_title--75da8";
export var name_box = "webinarSolution-module--name_box--89ca8";
export var solution_section = "webinarSolution-module--solution_section--f849c";